import * as $ from 'jquery';

export default class localNav {
	public $wrapperEl: JQuery = $('.nav--local');
	private selector_trigger: string = '.node--hasChild > a';
	private selector_target: string = '.childWrap';
	private selector_currentNode: string = '.childWrap .node--active';


	private toggleItem(element: Element, force?: boolean): void {
		const $element = $(element);
		const isOpen = $element.hasClass('target');

		if (isOpen){
			$element.removeClass('target');
			$element.next().stop(true).slideUp();
		} else {
			$element.addClass('target');
			$element.next().stop(true).slideDown();
		}
	}
	private setupEventHandlers(): void {
		this.$wrapperEl.on('click', this.selector_trigger, (event: JQueryMouseEventObject) => {
			event.preventDefault();
			this.toggleItem(event.currentTarget);
		});
	}

	constructor() {
		if (!this.$wrapperEl) {
			return;
		}
		this.setupEventHandlers();
		this.$wrapperEl.addClass('ready');

		var goo = () => {
			this.$wrapperEl.find(this.selector_target).slideUp(0);
		};
		$.when( goo() ).done(() => {
			const that = this;
			// opens current node
			this.$wrapperEl.find('a.active').each(function(){
				that.toggleItem(this);
			});
		});
	}
}
